import { render, staticRenderFns } from "./HandicapPromotionFee.vue?vue&type=template&id=04276cc2&scoped=true"
import script from "./HandicapPromotionFee.vue?vue&type=script&lang=js"
export * from "./HandicapPromotionFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04276cc2",
  null
  
)

export default component.exports